import { useScreenSize } from '@/hooks';
import type { SVGProps } from 'react';

type Props = Omit<SVGProps<SVGSVGElement>, 'width' | 'height'> & {
    width?: number;
    height?: number;
    fill?: string;
};
export const TurnRightIcon = ({ width = 40, height = 40, fill = 'currentColor', ...props }: Props) => {
    const { scaleHeightPixel, scaleWidthPixel } = useScreenSize();

    return (
        <svg width={scaleWidthPixel(width)} height={scaleHeightPixel(height)} viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
            <path d="M17 26V18.2342C17 17.5526 17.6584 17 18.4707 17L28 17.0001" stroke={fill} stroke-width="2" stroke-linecap="round" />
            <path d="M24 13L28 17L24 21" stroke={fill} stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
        </svg>
    );
};
